const PUSH_NOTIFICATIONS = 'Push Notifications'
const NEW_CONVERSATION = 'New Conversation'
const BACK = 'Back'
const SEND_MESSAGE = 'Send Message'

export { PUSH_NOTIFICATIONS, NEW_CONVERSATION, BACK, SEND_MESSAGE }
